if (!customElements.get('cart-drawer-progress')) {
  class CartDrawerProgress extends HTMLElement {
    connectedCallback() {
      this.freeShip = parseInt(this.dataset.freeShip) || 59900;
      this.tiers = [
        { qty: parseInt(this.dataset.t1Qty) || 2, pct: parseInt(this.dataset.t1Pct) || 10 },
        { qty: parseInt(this.dataset.t2Qty) || 3, pct: parseInt(this.dataset.t2Pct) || 20 }
      ];
      this.productPrice = parseInt(this.dataset.productPrice) || 54900;
      this._initEls();
      this.cartTotal = 0;
      this.cartCount = 0;
      this.fetchCart();

      /* Horizon hydrates the cart-drawer-inner section via requestIdleCallback
         AFTER page load, morphing DOM and wiping our rendered content.
         Re-render on staggered intervals to survive the hydration window. */
      [300, 900, 1800].forEach((ms) => {
        setTimeout(() => {
          const el = document.querySelector('cart-drawer-progress');
          if (el) el.fetchCart();
        }, ms);
      });

      /* Single shared listener on document — survives morph.
         Always resolves the LIVE element, never caches `this`.
         On every cart:update, fetch fresh from /cart.js.
         Event data can be stale (morph causes double-fire with cached HTML),
         so /cart.js is the only trustworthy source. */
      if (!CartDrawerProgress._listenerAttached) {
        CartDrawerProgress._listenerAttached = true;
        document.addEventListener('cart:update', () => {
          const el = document.querySelector('cart-drawer-progress');
          if (el) el.fetchCart();
          /* morphSection runs synchronously AFTER this event handler,
             wiping our rendered content. Re-fetch after morph settles. */
          setTimeout(() => {
            const el2 = document.querySelector('cart-drawer-progress');
            if (el2) el2.fetchCart();
          }, 300);
        });
      }
    }

    disconnectedCallback() {}

    _initEls() {
      this.els = {
        msg: this.querySelector('[data-msg]'),
        dots: this.querySelectorAll('.cdp__dot'),
        labels: this.querySelectorAll('.cdp__label'),
        segFills: this.querySelectorAll('.cdp__seg-fill')
      };
    }

    async fetchCart() {
      try {
        const r = await fetch('/cart.js');
        const c = await r.json();
        if (!this.isConnected) return;
        this.cartTotal = c.total_price;
        this.cartCount = c.item_count;
        this._initEls();
        this.render();
      } catch (_) {}
    }

    fmt(cents) {
      const kr = Math.floor(cents / 100);
      return kr.toLocaleString('nb-NO') + '\u00a0kr';
    }

    render() {
      if (!this.els?.msg) return;
      const { cartTotal: total, cartCount: count, freeShip, productPrice } = this;
      const t1 = this.tiers[0], t2 = this.tiers[1];

      const reached = [
        total >= freeShip,
        count >= t1.qty,
        count >= t2.qty
      ];

      /* Segment fills */
      const segPcts = [
        reached[0] ? 100 : (total > 0 ? Math.min(90, (total / freeShip) * 100) : 0),
        reached[1] ? 100 : 0,
        reached[2] ? 100 : 0
      ];
      this.els.segFills.forEach((f, i) => { f.style.width = segPcts[i] + '%'; });

      /* Dots + labels */
      [this.els.dots, this.els.labels].forEach(list => {
        list.forEach((el, i) => {
          el.classList.toggle('is-reached', reached[i]);
          const isNext = !reached[i] && (i === 0 || reached[i - 1]);
          el.classList.toggle('is-next', isNext);
        });
      });

      /* Status message */
      let msg = '';
      const sav = (c) => '<span class="cdp__sav">' + this.fmt(c) + '</span>';

      if (reached[2]) {
        const savings = productPrice * count * (t2.pct / 100);
        msg = '20% rabatt + fri frakt! Du har spart ' + sav(savings);
        this.dataset.state = 'success';
      } else if (reached[1]) {
        const savings = productPrice * count * (t1.pct / 100);
        msg = 'Legg til 1 til for hele 20%! Du har spart ' + sav(savings);
        this.dataset.state = 'tier1';
      } else if (reached[0]) {
        const need = t1.qty - count;
        msg = 'Fri frakt! Legg til ' + need + ' til for 10% p\u00e5 hele ordren';
        this.dataset.state = 'shipping';
      } else if (count > 0) {
        const remaining = Math.ceil((freeShip - total) / 100);
        msg = 'Kun ' + sav(remaining * 100) + ' til fri frakt';
        this.dataset.state = 'default';
      } else {
        msg = 'Fri frakt over 599\u00a0kr \u00b7 10% ved 2 stk \u00b7 20% ved 3 stk';
        this.dataset.state = 'empty';
      }

      this.els.msg.innerHTML = msg;
    }
  }
  customElements.define('cart-drawer-progress', CartDrawerProgress);
}
